import { Grid, Paper } from "@mui/material";
import TextBox from "@mv-components/TextBox/TextBox";
import Button from "@mv-components/Button/Button";
import Icon from "@components/Icon/Icon";
import { Icons } from "@utils/viewUtility";
import { styles } from "./styles";
import { InputType } from "@mv-types";
import { LoginForm } from "../constants";
import useStyles from "@hooks/useStyle";
import Typography from "@mv-components/Typography/Typography";

export default function Login(props: any) {
	const { handleChange, handleSubmit, controls, error } = props;

	const { classes, cx } = useStyles(styles) as any;
	const { WELCOME_MESSAGE, SIGN_IN_TITLE, SIGN_IN_INFO, SIGN_IN } = LoginForm;

	return (
		<Grid container direction="row" className={classes.root}>
			<Grid item>
				<Grid container direction="column" spacing={2} className={classes.widthRoot}>
					<Grid item>
						<Typography variant="h6" className={classes.mvTitle}>
							{WELCOME_MESSAGE}
						</Typography>
					</Grid>
					<Grid item className={classes.paddingTop0}>
						<Typography variant="body1"> {SIGN_IN_TITLE} </Typography>
					</Grid>
					<Grid className={classes.loginBox} item>
						<Paper elevation={1} className={classes.loginPaper}>
							<Grid container className={cx(classes.widthMargin, classes.widthFit)} spacing={2}>
								<Grid className={classes.widthFit} item>
									<Typography variant="body1" className={classes.bold}>
										{SIGN_IN_INFO}
									</Typography>
								</Grid>

								{Object.keys(controls).map((element, i) => {
									return (
										<Grid item className={cx(classes.paddingTop8, classes.widthFit)} key={i}>
											<TextBox onChange={handleChange} {...controls[element]} />
										</Grid>
									);
								})}

								{error?.errorMessage ? (
									<Typography variant="body1" color="error" className={classes.loginErrorMessage}>
										{error.errorMessage}
									</Typography>
								) : (
									""
								)}
								<Grid item xs={12}>
									<Button variant="itemWidth" onClick={handleSubmit} elementType={InputType.BUTTON}>
										{SIGN_IN}
									</Button>
								</Grid>
							</Grid>
						</Paper>
					</Grid>
				</Grid>
			</Grid>
			<Grid item className={classes.svgIconSec} flexGrow="1">
				<Icon iconType={Icons.LOGIN_BANNER} />
			</Grid>
		</Grid>
	);
}
